import SpinnerLoader from "../../../components/loader/spinner-loader";
import Naira from "../../../components/naira";
import { useMetricOverview } from "../../../composables/dashboard/useMetricOverview"
import { formatNumber, numberWithCommas } from "../../../lib/helper-support";

const MetricTab = ({ title, category, money_format = false, from, to }: {
    title: string,
    category: string,
    money_format?: boolean,
    from?: string,
    to?: string
}) => {
    const { data, isLoading } = useMetricOverview({
        enabled: true,
        category,
        from,
        to,
    })

    return <div className='p-5 bg-primary-light rounded-[13px] relative h-[10em] md:h-[12em]'>
        {!isLoading ? <>{data ? <>
            <div className='flex items-center justify-between'>
                <h4 className='font-[600] text-[13px] uppercase'>{title}</h4>
            </div>
            <div className='absolute top-14'>
                <h4 className='text-blue-black font-[600] md:text-[3em] text-[2.5em]'>
                    {money_format ? <><Naira />{formatNumber(data?.value || '')}</> : data?.value}
                </h4>
                {money_format && <p className='text-gray-shade text-[13px] font-[600] mt-2 flex items-center'>
                    <Naira />{numberWithCommas(data?.value || '')}.<span className='text-[11px]'>{numberWithCommas(data?.value || '', true, true)}</span>
                </p>}
            </div>
        </> : <p className="text-xs text-secondary font-bold">could not get data</p>}</>  : <SpinnerLoader />}
    </div>;
}

export default MetricTab